<template>
    <div
        class="app-header"
        :class="color"
    >
        <div class="header-left">
            <i
                v-if="showBack"
                class="fas fa-angle-left"
                @click="goBack"
            ></i>
        </div>

        <div class="header-title">
            <h3 class="mb-0">{{ title }}</h3>
        </div>

        <div
            class="header-right"
            v-if="hasActions"
        >
            <slot name="action">
                <div
                    class="mx-3 d-flex flex-column"
                    @click="$router.go()"
                >
                    <i class="fas fa-redo mx-auto"></i>
                    <div style="font-size: 10px;">
                        {{ $store.state.language === 'en' ? 'Refresh' : 'Refresh' }}
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "AppHeader",
    props: {
        title: {
            type: String,
            default: "SKK",
            required: true
        },
        showBack: {
            type: Boolean,
            default: false
        },
        hasActions: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "black", // "black" or "white"
            validator: val => ["black", "white"].includes(val)
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
};
</script>

<style scoped>
.app-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 6px;
    position: relative;
}

.header-left,
.header-right {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
}

.header-title h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}

.header-left i {
    font-size: 20px;
}

i {
    cursor: pointer;
}

/* 🔥 Force color down */
.black,
.black * {
    color: black !important;
}

.white,
.white * {
    color: white !important;
}
</style>
